// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/damienclarke/projects/mosfez-site/packages/mosfez-site/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/damienclarke/projects/mosfez-site/packages/mosfez-site/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pixel-js": () => import("/Users/damienclarke/projects/mosfez-site/packages/mosfez-site/src/pages/pixel.js" /* webpackChunkName: "component---src-pages-pixel-js" */),
  "component---src-pages-sequence-js": () => import("/Users/damienclarke/projects/mosfez-site/packages/mosfez-site/src/pages/sequence.js" /* webpackChunkName: "component---src-pages-sequence-js" */)
}

